<section class="section font-pt-sans">
  <div class="section-content">
    <div class="section-main">
      <div class="section-content-container section-2-content-container">
        <text-header i18n>Z kim mogę porozmawiać?</text-header>

        <text i18n>
          Na naszym pokładzie znajdziecie załogę z której jesteśmy naprawdę dumni, ponad 100
          <span style="font-weight: 700"
            >psychologów, psycholożek, psychiatrów, psychoterapeutek, psychoterapeutów, seksuologów,
            seksuolożek</span
          >
          czeka by z Wami porozmawiać i wspólnie zmierzyć się z tym wszystkim co Was na codzień
          trapi.
        </text>

        <text i18n>
          W najbliższej przyszłości będziemy chcieli poszerzyć naszą ofertę o doświadczonych<span
            style="font-weight: 700"
          >
            trenerów i trenerki rozwoju osobistego a także mentorów i mentorki</span
          >
          co pozwoli nam pomóc Wam we wszystkich ważnych dla Was obszarach życia.
        </text>

        <text i18n> ściskamy, Załoga Porozmawiaj.my :-) </text>
      </div>
    </div>
  </div>
</section>
